import { RichText } from 'prismic-reactjs';
import React from 'react';

import { PrismicFieldEmbed, PrismicItemRichText } from '../../types/prismic';
import { richTextAsString } from '../../util/rich-text-as-string';

import { htmlSerializer } from './serializer';

import './PrismicRichText.scss';

const PrismicRichText: React.FC<{
  content: PrismicItemRichText[] | ({ type: 'embed'; oembed: PrismicFieldEmbed })[] | undefined;
  asString?: boolean;
}> = ({ content, asString = false }) => {
  if (!content) return null;

  if (asString) {
    const richTextString = richTextAsString(content);
    if (richTextString) return <>{richTextString}</>;
    return null;
  }

  return (
    <div className="rt">
      <RichText
        render={content}
        htmlSerializer={htmlSerializer}
      />
    </div>
  );
};

export default PrismicRichText;
